import React from 'react';
var FourOThree = function FourOThree(_ref) {
  var customMessage = _ref.customMessage;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h2", null, "ERROR 403"), /*#__PURE__*/React.createElement("h1", null, "Access Denied"), /*#__PURE__*/React.createElement("p", null, customMessage ? customMessage : 'You are not authorized to access this page.'));
};
export default FourOThree;